import jump from 'jump.js'

const scrollTo = ($target, additionalOffset = 0, callback) => {
  const $header = document.querySelector('.site-header')
  const headerOffset = $header.offsetHeight * -1
  const offset = headerOffset - additionalOffset

  jump($target, { duration: 500, offset, callback })
}

export default scrollTo
